<div class="field row" *ngIf="value != null">
  <label class="field-label" translate="capitalCostLabel"></label>
  <span class="field-data qa-capital-cost-value" [textContent]="value | localeCurrency"></span>
</div>